import React, { useEffect } from "react";
import Common_title from "../common-components/common-title/Common_title";
import { useDispatch, useSelector } from "react-redux";
import { getShippingPolicy } from "../../features/privacypolicy/Slice";

const Shipping_Policy = () => {
  const dispatch = useDispatch();
  const policy = useSelector(
    (state) => state.privacypolicy.shippingpolicies
  );

  useEffect(() => {
    dispatch(getShippingPolicy());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <section className="Shipping_Policy">
      <div className="container">
        <Common_title title={"Shipping"} titleblack={"Policy"} />
        <div className="content_div">
          {" "}
          {policy && policy.content ? (
            <div
              className="description_text"
              dangerouslySetInnerHTML={{ __html: policy.content }}
            />
          ) : (
            <p className="no-data">No Shipping Policy Available</p>
          )}
        </div>
        {/* <div className="content_div">
          <p className="simple_black_text">Shipping Policy</p>
          <p className="simple_black_text">General Site Usage</p>
          <p className="simple_black_text mb-3">
            Last Revised: December 16, 2013
          </p>

          <p className="description_text">
            {" "}
            <span className="blue_text">Welcome to www.lorem-ipsum.info. </span>
            This site is provided as a service to our visitors and may be used
            for informational purposes only. Because the Terms and Conditions
            contain legal obligations, please read them carefully.
            description_text
          </p>

          <p className="point_no_text">1. YOUR AGREEMENT</p>
          <p className="description_text">
            By using this Site, you agree to be bound by, and to comply with,
            these Terms and Conditions. If you do not agree to these Terms and
            Conditions, please do not use this site.
          </p>

          <p className="description_text">
            {" "}
            <span className="blue_text">PLEASE NOTE: </span>
            We reserve the right, at our sole discretion, to change, modify or
            otherwise alter these Terms and Conditions at any time. Unless
            otherwise indicated, amendments will become effective immediately.
            Please review these Terms and Conditions periodically. Your
            continued use of the Site following the posting of changes and/or
            modifications will constitute your acceptance of the revised Terms
            and Conditions and the reasonableness of these standards for notice
            of changes. For your information, this page was last updated as of
            the date at the top of these terms and conditions.
          </p>

          <p className="point_no_text">2. Shipping</p>
          <p className="description_text">
            Please review our Shipping Policy, which also governs your visit to
            this Site, to understand our practices.
          </p>

          <p className="point_no_text"> 3. LINKED SITES</p>
          <p className="description_text">
            This Site may contain links to other independent third-party Web
            sites ("Linked Sites”). These Linked Sites are provided solely as a
            convenience to our visitors. Such Linked Sites are not under our
            control, and we are not responsible for and does not endorse the
            content of such Linked Sites, including any information or materials
            contained on such Linked Sites. You will need to make your own
            independent judgment regarding your interaction with these Linked
            Sites.
          </p>

          <p className="point_no_text"> 4. FORWARD LOOKING STATEMENTS</p>
          <p className="description_text">
            All materials reproduced on this site speak as of the original date
            of publication or filing. The fact that a document is available on
            this site does not mean that the information contained in such
            document has not been modified or superseded by events or by a
            subsequent document or filing. We have no duty or policy to update
            any information or statements contained on this site and, therefore,
            such information or statements should not be relied upon as being
            current as of the date you access this site.
          </p>

          <p className="point_no_text"> 5. FORWARD LOOKING STATEMENTS</p>
          <p className="description_text">
            All materials reproduced on this site speak as of the original date
            of publication or filing. The fact that a document is available on
            this site does not mean that the information contained in such
            document has not been modified or superseded by events or by a
            subsequent document or filing. We have no duty or policy to update.
          </p>

          <p className="point_no_text">
            {" "}
            5. DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY
          </p>
          <p className="description_text">
           This Site and all its Contents are
            intended solely for personal, non-commercial use. Except as
            expressly provided, nothing within the Site shall be construed as
            conferring any license under our or any third party's intellectual
            property rights, whether by estoppel, implication, waiver, or
            otherwise. Without limiting the generality of the foregoing, you
            acknowledge and agree that all content available through and used to
            operate the Site and its services is protected by copyright,
            trademark, patent, or other proprietary rights. You agree not to:
            (a) modify, alter, or deface any of the trademarks, service marks,
            trade dress (collectively "Trademarks") or other intellectual
            property made available by us in connection with the Site; (b) hold
            yourself out as in any way sponsored by, affiliated with, or
            endorsed by us, or any of our affiliates or service providers; (c)
            use any of the Trademarks or other content accessible through the
            Site for any purpose other than the purpose for which we have made
            it available to you; (d) defame or disparage us, our Trademarks, or
            any aspect of the Site; and (e) adapt, translate, modify, decompile,
            disassemble, or reverse engineer the Site or any software or
            programs used in connection with it or its products and services.
          </p>

          <p className="point_no_text">
            {" "}
            7. DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY
          </p>
          <p className="description_text">
            This Site and all its Contents are
            intended solely for personal, non-commercial use. Except as
            expressly provided, nothing within the Site shall be construed as
            conferring any license under our or any third party's intellectual
            property rights, whether by estoppel, implication, waiver, or
            otherwise. Without limiting the generality of the foregoing, you
            acknowledge and agree that all content available through and used to
            operate the Site and its services is protected by copyright,
            trademark, patent, or other proprietary rights. You agree not to:
            (a) modify, alter, or deface any of the trademarks, service marks,
            trade dress (collectively "Trademarks") or other intellectual
            property made available by us in connection with the Site; (b) hold
            yourself out as in any way sponsored by, affiliated with, or
            endorsed by us, or any of our affiliates or service providers; (c)
            use any of the Trademarks or other content accessible through the
            Site for any purpose other than the purpose for which we have made
            it available to you; (d) defame or disparage us, our Trademarks, or
            any aspect of the Site; and (e) adapt, translate, modify, decompile,
            disassemble, or reverse engineer the Site or any software or
            programs used in connection with it or its products and services.
          </p>
        </div> */}
      </div>
    </section>
  );
};

export default Shipping_Policy;
